<template>
    <div class="eventList" v-infinite-scroll="loadMore" infinite-scroll-disabled="pullUpLoading"
         infinite-scroll-distance="10">
        <section class="selectFixed">
            <div class="bg_fff fixedBox flex_box fs14">
                <p :class="{ upIcon: openList === 'time' }" @click="openOptions('time')">{{ timeActive }}
                    <img src="../assets/img/icon/icon_down_black.svg" alt="downIcon">
                </p>
            </div>
        </section>
        <section class="listBg" v-for="(item) in renderList" :key="item._id">
            <div class="listBox flex_box">
                <div class="list">
                    <p class="elli2 fs14 co_333">{{ item.title }}</p>
                    <div class="textBox flex_box mt6">
                        <p class="flex_1 fs10 co_B0">{{ item.lastMedia.media || item.media }}
                            {{ item.forwardCount ? "| 转载量" + item.forwardCount : "" }}</p>
                        <span class="text_r timeBox fs10 co_B0">{{ item.lastCreated | formatDateStr }}</span>
                    </div>
                </div>
            </div>
        </section>

        <img v-if="!renderList.length" class="noDataImg hasMargin" src="../assets/img/company/noEventData.svg" alt="">

        <section class="loadingBg" v-if="loading">
            <mt-spinner type="double-bounce" color="#26a2ff"></mt-spinner>
        </section>
        <section v-if="openList" class="popupChooseBox">
            <EventChoose :popupVisible="popupVisible" :renderType="openList" :activeOption="activeOption"
                         @selectedOption="selectedOption"></EventChoose>
        </section>
        <div class="place"></div>
    </div>
</template>

<script>
import moment from 'moment'
import utils from "@/util/common";
import common from "@/util/common";

const noChoose = require('../assets/img/icon/noChoose.png')
const allChoose = require('../assets/img/icon/allChoose.png')
const partChoose = require('../assets/img/icon/partChoose.png')

export default {
    name: "EventList",
    components: {
        EventChoose(render) {
            require(["@/components/common/EventChoose"], render)
        },
    },
    data() {
        return {
            currentPage: 0,
            firstLoad: true,
            loading: false,
            pullUpLoading: false,
            query: {
                company: "",
                start: moment().startOf('day').valueOf(),
                end: moment().endOf('day').valueOf(),
                sort: "-lastCreated -forwardCount",
                skip: 0,
                limit: 20
            },
            renderList: [],
            openList: '',
            noChoose: noChoose,
            allChoose: allChoose,
            partChoose: partChoose,
            selectArr: [],
            activeOption: '',
            eventActive: '全部事件',
            timeActive: '今日',
            popupVisible: false,
            isLogin: !!utils.getCookie("xinhuaToken")
        }
    },
    mounted() {
        let {company} = this.$route.query;
        this.query.company = company || "";
        this.getData()
    },
    filters: {
        formatDateStr(date, unit = "YYYY/MM/DD HH:mm") {
            return  common.formatStr(date, unit)
        }
    },
    methods: {
        async getData() {
            this.loading = true;
            this.pullUpLoading = true;

            this.query.start = utils.getTimeName(this.timeActive)
            this.query.skip = this.currentPage * this.query.limit;

            let res = await this.baseApi.warning(this.query)
            this.renderList = this.renderList.concat(res.list || []);
            this.pullUpLoading = this.renderList.length === res.count;
            this.loading = false;
        },
        openOptions(name) {
            if (this.popupVisible && this.openList === name) {
                this.openList = '';
                this.popupVisible = false;
                return
            }
            this.openList = name;
            this.popupVisible = true;
            this.activeOption = this[`${name}Active`];
        },
        selectedOption(data) {
            this[data.keyword] = data.value;
            this.openList = "";
            this.popupVisible = false;
            this.query.skip = 0;
            this.currentPage = 0;
            this.renderList = [];
            this.getData()
        },
        async loadMore() {
            if (this.firstLoad) {
                this.firstLoad = false;
                return;
            }
            this.currentPage++;
            await this.getData();
        },
    }
}
</script>

<style lang="scss" scoped>
.eventList {
    .listBg {
        width: 343px;
        margin: 8px auto 0;
        border: 1px solid #EDEDED;
        border-radius: 4px;

        .topContent {
            height: 37px;
            line-height: 37px;
            background-color: rgba(237, 237, 237, 0.3);
            padding: 14px;

            .littlePoint {
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background-color: #F7634F;
                margin-right: 8px;
            }
        }

        .listBox {
            background-color: #FFFFFF;
            padding: 12px;

            .list {
                width: 100%;
            }

            .leftCheckBox {
                width: 16px;
                height: 16px;
                margin-right: 12px;
                margin-top: 2px;

                img {
                    width: 16px;
                    height: 16px;
                }
            }
        }
    }

    .footBoxBg {
        width: 100vw;
        height: 48px;
        line-height: 48px;

        .footBox {
            width: 100%;
            height: 48px;
            line-height: 48px;
            position: fixed;
            bottom: 0;
            left: 0;

            .leftBox {
                width: 120px;
                height: 100%;
                background-color: #FFFFFF;
                padding-left: 16px;

                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 8px;
                }
            }

            .rightBox {
                background-color: #538DFF;
            }
        }
    }

    .place {
        height: 60px;
    }

    .exportFooter.inActive {
        background: #c9c9ca;
        pointer-events: none;
    }
}
</style>